<template>
    <div>
        <b-card>
            <b-card-header @click="showStopDetails($event)">
                <b-row>
                    <i class="fa-solid fa-gear"></i>
                    Anktid: {{ Math.round(stop.arrivalTime) }}min. {{ stop.arrivalTimeStr ? '(' + stop.arrivalTimeStr +
                        ')'
                    : '' }}
                </b-row>
                <b-row v-if="stop.kpi">
                    Stopptid: {{ stop.kpi.workMinutes }}min.
                </b-row>
            </b-card-header>
        </b-card>
        <!-- {{ stop }} -->
        <b-list-group>
            <div v-for="(a, i) in getActions()" :key="i" draggable="true" @dragstart="dragStart($event, a)"
                @dragover.prevent>
                <b-list-group-item @click="showAction($event, a)" @mouseover="actionHover = a"
                    @mouseleave="actionHover = null">
                    <i class="fa-solid fa-up-long" v-if="a.type == 'PU'"></i>
                    <i class="fa-solid fa-down-long" v-if="a.type == 'DLV'"></i>
                    {{ a.booking.name }}
                    <i class="fa-regular fa-object-ungroup" title="Lägg på separat stopp" v-show="actionHover === a"
                        @click="isolateAction($event, a, stop)"></i>
                    <!-- {{ actionHover }} -->
                </b-list-group-item>
            </div>
        </b-list-group>
        <b-modal title="Order" size="xl" v-model="bookingDetailsVisible">
            <b-card>
                <b-card-header>
                    <b-button @click="openInNewWindow(bookingDetailsSrc)">Öppna i separat fönster</b-button>
                </b-card-header>
                <iframe :src="bookingDetailsSrc" width="100%" height="1200px"></iframe>
            </b-card>

        </b-modal>
        <b-modal title="Stopp" v-model="stopDetailsVisible" ok-only>
            <b-card>
                <b-card-header>
                    {{ stop.text }}
                </b-card-header>
                <b-card-body v-if="stop.kpi">
                    <b-row>
                        <b-col>Antal kollin:</b-col>
                        <b-col>{{ stop.kpi.collisCount }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col>Antal order:</b-col>
                        <b-col>{{ stop.kpi.bookingsCount }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            Beräknad ankomsttid (minuter):
                        </b-col>
                        <b-col>
                            {{ Math.round(stop.arrivalTime) }} {{ stop.arrivalTimeStr ? '(' + stop.arrivalTimeStr + ')'
                                : '' }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>Beräknad körtid (minuter):</b-col>
                        <b-col>{{ stop.kpi.driverMinutes?Math.round(stop.kpi.driverMinutes):'-' }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col>Beräknad stopptid (minuter):</b-col>
                        <b-col>{{ stop.kpi.workMinutes }}</b-col>
                    </b-row>
                    <b-row v-if="work">
                        <b-col title="Skriver över den beräknade stopptiden.">Manuell stopptid (minuter):<i
                                class="fa-solid fa-circle-info"></i></b-col>
                        <b-col><input type="number" v-model="work.kpi.manWorkMinutes" placeholder="Ange minuter"
                                @input="manWorkTimeChanged"></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
            <b-card>
                <b-card-header>Adress:
                    <!-- TODO -->
                    <b-button size="sm" title="Geokodning" @click="Geocode($event)"><i
                            class="fa-solid fa-map-pin"></i></b-button>
                </b-card-header>
                <b-card-body v-if="stop.place">
                    <b-row>
                        <b-col>
                            {{ stop.place.name }}<br />
                            {{ stop.place.street }}<br />
                            {{ stop.place.street2 }}<br />
                            {{ stop.place.postCode }}&nbsp;{{ stop.place.city }}<br />
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-modal>
        <b-modal v-model="geocodeVisible" size="xl" ok-only>
            <h1>Geokoda</h1>
            <geocode v-if="stop && stop.place" :place="stop.place" @geocoded="onGeoCoded($event)"></geocode>
        </b-modal>
    </div>
</template>
<script>
import Geocode from './geocode.vue';
import Settings from "../../lib/settings";

import { Api } from "../../lib/api";
const api = new Api();


export default {
    name: 'stopdetails',
    props: { stop: Object },
    components: { Geocode },
    created() {
        this.refreshWork();
    },
    watch: {
        manWorkMinutes() {

        },
        stop() {
            this.refreshWork();
        }
    },
    data() {
        return {
            work: {},
            bookingDetailsVisible: false,
            bookingDetailsSrc: null,
            stopDetailsVisible: false,
            geocodeVisible: false,
            actionHover: null,
            // manWorkMinutes: null,
        }
    },
    methods: {
        refreshWork() {
            this.work = JSON.parse(JSON.stringify(this.stop));
        },
        getActions() {
            //return this.stop.actions.sort((a,b)=> `${a.type}|${a.name}`<`${b.type}|${b.name}`?-1:1);
            return this.stop.actions; //Sorting caused: "You may have an infinite update loop in a component render function."
        },
        dragStart(ev, a) {
            // alert('dragstart i stopp')
            if (ev)
                ev.stopPropagation();
            this.$emit('setdrag', { type: 'action', action: a })
        },
        // handleItemDragStart(event) {
        //     console.log("Item dragstart event");

        //     // Stop the event from propagating to the container
        //     event.stopPropagation();
        // }
        showAction(ev, a) {
            if (ev)
                ev.stopPropagation();
            //TODO: Move to settings
            //https://sodexosthlm.logivia.se
            //var baseUrl = Settings.SodexoTpBaseUrl;
            var baseUrl = Settings.instanceSpecific().sodexoTpBaseUrl;
            var src = baseUrl + '/consolidation/editpartial?id=' + a.booking.id;
            //window.open(src);
            this.bookingDetailsSrc = src;
            this.bookingDetailsVisible = true;
        },
        openInNewWindow(src) {
            window.open(src);
        },
        showStopDetails(ev) {
            if (ev)
                ev.stopPropagation();
            this.stopDetailsVisible = true;
        },
        Geocode(ev) {
            if (ev)
                ev.stopPropagation();
            this.geocodeVisible = true;
        },
        onGeoCoded(ev) {
            //Not impelemented yet!
            var bIds = this.stop.actions.map(x => x.booking.id);
            var p = { bookingIds: bIds, geoPlaceId: ev.id };
            api.post('/api/geo/UpdateBookingGeoCode', p).then(res => {
                ev.updatedBookingIds = res.data;
                this.$emit('geocoded', ev);
            });

        },
        manWorkTimeChanged() {
            this.$emit('stopworktimechanged', { stop: this.stop, manWorkMinutes: Number(this.work.kpi.manWorkMinutes) });
        },
        getActualStopTime(kpi) {
            return kpi.manWorkMinutes ? kpi.manWorkMinutes : kpi.workMinutes;
        },
        isolateAction(ev, a, stp) {
            if (ev)
                ev.stopPropagation();
            if (this.stop.actions.length <= 1) {
                alert('Det går inte att lägga en order på ett separat stopp när det bara finns en order på stoppet.');
                return;
            }
            if (confirm('Vill du lägga "' + a.booking.name + '" på ett separat stopp?'))
                this.$emit('isolateaction', { stp: stp, action: a });
        }
    }
}

</script>

<style scoped>
.container {
    width: 300px;
    height: 300px;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.draggable-item {
    width: 100px;
    height: 100px;
    background-color: #3498db;
    cursor: grab;
}
</style>